/**
 * Marca do "Sair" explícito nesta aba (C8 da change platform-backoffice-hardening, revisão E16).
 *
 * O "Sair" limpa a memória na hora, antes de a API confirmar o `/logout`. Se o `/logout` falhar,
 * o cookie `platform_refresh` segue vivo, e sem esta marca o próximo carregamento da página
 * (`bootstrapSession`) o trocaria por um access e entraria de novo como o operador que saiu.
 * Enquanto a marca existir, nenhuma sessão volta pelo cookie sozinha: só um login concluído a
 * apaga ({@link clearExplicitLogout}).
 *
 * Fica no `sessionStorage` (por aba, some ao fechar a aba) e guarda só `"1"`, nunca token. Storage
 * indisponível (modo privado, política do navegador) não quebra nada: a marca vale, então, só na
 * memória desta carga da página.
 */
export const EXPLICIT_LOGOUT_KEY = 'platform-admin-explicit-logout';

let inMemory = false;

export function markExplicitLogout(): void {
  inMemory = true;
  try {
    sessionStorage.setItem(EXPLICIT_LOGOUT_KEY, '1');
  } catch {
    // Sem storage, vale a marca em memória.
  }
}

export function isExplicitLogout(): boolean {
  if (inMemory) return true;
  try {
    return sessionStorage.getItem(EXPLICIT_LOGOUT_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearExplicitLogout(): void {
  inMemory = false;
  try {
    sessionStorage.removeItem(EXPLICIT_LOGOUT_KEY);
  } catch {
    // Sem storage, não há o que apagar.
  }
}
